module.exports = __webpack_public_path__ + "media/images/athletes/157-c39d363ae5136ae705df0d7184dbc608.png";